<script setup lang="ts">
import EstateDetail from '~/components/estate/detail/EstateDetail.vue'
import { useEstateDetailData } from '~/composables/api/useEstateDetailData'
import type { EstateDetailInterface } from '~/types/api/EstateDetail'

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    en: '/retail/[slug]/[id]',
    sk: '/obchodne-priestory/[slug]/[id]',
  },
})

const { t } = useI18n()
const route = useRoute()

const estateData = await useAsyncData<EstateDetailInterface>(async () => {
  return await useEstateDetailData({
    estateType: 'retail',
    id: route.params.id.toString(),
  })
})

if (estateData.error.value) {
  const urlParts = route.fullPath.split('/')
  let redirectUrl = '/' + urlParts[1]

  if (urlParts[1] === 'en') {
    redirectUrl = '/en/' + urlParts[2]
  }

  await navigateTo({
    path: redirectUrl,
  })

  // throw createError({
  //   statusCode: 404,
  //   statusMessage: t('pages.estateDetail.notFound.retail'),
  // })
}

// redirect, if url slug is not matching the slug in fetched data
if (
  estateData.data.value &&
  estateData.data.value?.slug !== route.params.slug
) {
  await navigateTo({
    path: getEstateDetailLink({
      estateType: estateData.data.value.type,
      slug: estateData.data.value.slug,
      id: estateData.data.value.id,
    })?.fullPath,
  })
}

useHead({
  title: `${estateData.data.value?.name} - ${t('pages.estateListing.detail.titles.retail')}`,
  meta: [
    {
      name: 'description',
      content: t('pages.estateListingDetail.description', {
        _0: estateData.data.value?.name,
        _1: estateData.data.value?.town,
      }),
    },
  ],
})

useEstateDetailDataSetter(estateData.data.value)
</script>

<template>
  <EstateDetail
    v-if="estateData.data.value"
    estate-type="retail"
    :estate-data="estateData.data.value"
  />
</template>
